import { hasRoleAdmin, hasRolePartnerAdmin } from 'common/utility/userRoles';

export function canManagePartnerApiKeys(utilityUser, utilityPartner) {
  if (!utilityPartner?.apiAccessEnabled || utilityUser?.partnerViewAs) {
    return false;
  }
  const roles = utilityUser?.roles || [];
  if (hasRoleAdmin(roles)) {
    return true;
  }
  return Boolean(utilityUser?.partners?.some(
    (partner) => partner.id === utilityPartner.id && (
      partner.position === 'owner' || hasRolePartnerAdmin(roles)
    ),
  ));
}

export function getSafeUtilityLoginReturnPath(next) {
  return typeof next === 'string' && next.startsWith('/') &&
    !next.startsWith('//') && !next.includes('\\') &&
    !Array.from(next).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127) ? next : null;
}
